<template>
    <div class="newsBannerPC">
        <img src="../../public/img/left.jpg" class="left" @click="add()">
        <div class="showView">
            <div class="showViewList" :style="`width:${bannerList.length*20}vw;left:${-index*20}vw;`">
                <div class="item" v-for="(item, index) in bannerList" :key="index">
                    <div class="itemImg" :style="`background-image:url('${baseUrl+'img/news/'+item.img}')`" @click="gotoNewsInfo(index)">
                        <div class="itemText">{{item.title}}</div>
                    </div>
                </div>
            </div>
        </div>
        <img src="../../public/img/right.jpg" class="right" @click="cut()">
        <div class="more" @click="gotoNews()">
            <div>{{$t('更多')}}</div>
            <img src="../../public/img/right.png" alt="" srcset="">
        </div>
    </div>
</template>
<script>
import {getNewsData} from "../datas/newsData.js"
export default {
    data() {
        return {
           baseUrl:process.env.BASE_URL, 
           index:0,
           bannerList:[]
        }
    },
    created(){
        this.render()
    },
    watch: {
        '$route' (to, from) {
            this.render()
        },
        '$i18n.locale'(){
            this.render()
        },
    },
    methods:{
        cut(){
            if(this.index<this.bannerList.length-3){
                this.index++
            }
        },
        add(){
            if(this.index>0){
                this.index--
            }
        },
        render(){
            this.bannerList = getNewsData()
        },
        gotoNews(){
            this.$router.push('/news')
        },
        gotoNewsInfo(index){
            this.$router.push('/newsDetails/'+index)
        }
    }
}
</script>
<style lang="less">
.newsBannerPC{
    height: 40vh;
    width: 80%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(0,-20%);
    position: relative;
    .more{
        position: absolute;
        left: 50%;
        cursor: pointer;
        bottom: 0%;
        transform: translate(-50%,0);
        width: 4rem;
        height: 1.8rem;
        border-radius: 1.5rem;
        border: #017CA4 1.5px solid;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.8rem;
        font-weight: 400;
        // font-weight: 700;
        // background-color: red;
        color: #017CA4;
        img{
            height: 50%;
        }
    }
    .showView{
        width:60vw;
        height: 60%;
        overflow: hidden;
        position: relative;
        .showViewList{
            position: absolute;
            left: 0;
            top: 0;
            transition: 0.5s ease-in-out all;
            height: 100%;
            .item:hover{
                transform: scale(1.1);
            }
            .item{
                cursor: pointer;
                transition: 0.3s all linear;
                width: 20vw;
                float: left;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                .itemImg{
                    width: 90%;
                    height: 90%;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center;
                    box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
                    position: relative;
                    .itemText{
                        color: #fff;
                        position: absolute;
                        bottom: 10px;
                        font-size: 0.7rem;
                        text-align: center;
                        width: 100%;
                        text-overflow:ellipsis;
                        overflow:hidden;
                        white-space:nowrap; 
                        z-index: 1000;
                    }
                }
                .itemImg::before{
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 100;
                    opacity: 0.8;
                    background-image: linear-gradient(rgba(1, 124, 164,0.2), #017CA4);
                }
            }
        }
    }
    .left{
        width: 2rem;
        height: 2rem;
        background-color: #fff;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 50%;
    }
    .right{
        width: 2rem;
        height: 2rem;
        background-color: #fff;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 50%;
    }
}
</style>
<i18n>
{
  "en": {
    "新闻1":"[朝 闻 天下] Hubei Xiantao is full of horsepower to produce medical protective materials",
    "新闻2":"CCTV \"Newscast\" focuses on Xiantao! This time because ...", 
    "新闻3":"Hubei Daily Concerned about Xiantao: \"No Stop\" Enterprises Are \"Arsenals\"",
    "更多":"More"                            
  },
  "zh": {
    "新闻1":"[朝闻天下]湖北仙桃开足马力 生产医用防护物资",
    "新闻2":"央视《新闻联播》聚焦仙桃！这次是因为……", 
    "新闻3":"湖北日报关注仙桃：“停不得”企业就是“兵工厂”",
    "更多":"更多"
  }
}
</i18n>
